var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.74986V11.0946C1 11.1941 1.03951 11.2895 1.10984 11.3598C1.18016 11.4301 1.27554 11.4696 1.375 11.4696H2.71975C2.81901 11.4696 2.91422 11.4302 2.9845 11.3601L9.3595 4.98511L7.4845 3.11011L1.1095 9.48511C1.0394 9.55539 1.00002 9.6506 1 9.74986ZM8.9425 1.65211L10.8175 3.52711L11.7198 2.62486C11.8604 2.48422 11.9393 2.29349 11.9393 2.09461C11.9393 1.89574 11.8604 1.70501 11.7198 1.56436L10.9053 0.749863C10.7646 0.60926 10.5739 0.530273 10.375 0.530273C10.1761 0.530273 9.9854 0.60926 9.84475 0.749863L8.9425 1.65211Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfile);
export default __webpack_public_path__ + "static/media/edit-profile.67f55ed10d107f0640b1d4eda5b4ddbd.svg";
export { ForwardRef as ReactComponent };